/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateToolsetRequestBody,
  CreateToolsetRequestBody$Outbound,
  CreateToolsetRequestBody$outboundSchema,
} from "../components/createtoolsetrequestbody.js";

export type CreateToolsetSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateToolsetSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateToolsetSecurity = {
  option1?: CreateToolsetSecurityOption1 | undefined;
  option2?: CreateToolsetSecurityOption2 | undefined;
};

export type CreateToolsetRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createToolsetRequestBody: CreateToolsetRequestBody;
};

/** @internal */
export type CreateToolsetSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateToolsetSecurityOption1$outboundSchema: z.ZodMiniType<
  CreateToolsetSecurityOption1$Outbound,
  CreateToolsetSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createToolsetSecurityOption1ToJSON(
  createToolsetSecurityOption1: CreateToolsetSecurityOption1,
): string {
  return JSON.stringify(
    CreateToolsetSecurityOption1$outboundSchema.parse(
      createToolsetSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateToolsetSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateToolsetSecurityOption2$outboundSchema: z.ZodMiniType<
  CreateToolsetSecurityOption2$Outbound,
  CreateToolsetSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function createToolsetSecurityOption2ToJSON(
  createToolsetSecurityOption2: CreateToolsetSecurityOption2,
): string {
  return JSON.stringify(
    CreateToolsetSecurityOption2$outboundSchema.parse(
      createToolsetSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateToolsetSecurity$Outbound = {
  Option1?: CreateToolsetSecurityOption1$Outbound | undefined;
  Option2?: CreateToolsetSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateToolsetSecurity$outboundSchema: z.ZodMiniType<
  CreateToolsetSecurity$Outbound,
  CreateToolsetSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateToolsetSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateToolsetSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createToolsetSecurityToJSON(
  createToolsetSecurity: CreateToolsetSecurity,
): string {
  return JSON.stringify(
    CreateToolsetSecurity$outboundSchema.parse(createToolsetSecurity),
  );
}

/** @internal */
export type CreateToolsetRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateToolsetRequestBody: CreateToolsetRequestBody$Outbound;
};

/** @internal */
export const CreateToolsetRequest$outboundSchema: z.ZodMiniType<
  CreateToolsetRequest$Outbound,
  CreateToolsetRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createToolsetRequestBody: CreateToolsetRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createToolsetRequestBody: "CreateToolsetRequestBody",
    });
  }),
);

export function createToolsetRequestToJSON(
  createToolsetRequest: CreateToolsetRequest,
): string {
  return JSON.stringify(
    CreateToolsetRequest$outboundSchema.parse(createToolsetRequest),
  );
}
